module.exports = __webpack_public_path__ + "img/news36-0.81bab7d4.png";